// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgFolderRec24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M20.3572 5.99986C20.3572 4.10631 18.8222 2.57129 16.9286 2.57129C15.0351 2.57129 13.5001 4.10631 13.5001 5.99986V10.2856C13.5001 12.1791 15.0351 13.7141 16.9286 13.7141C18.8222 13.7141 20.3572 12.1791 20.3572 10.2856V5.99986ZM22.7144 10.2856C22.7144 9.93053 22.4265 9.64272 22.0715 9.64272C21.7165 9.64272 21.4286 9.93053 21.4286 10.2856C21.4286 12.7709 19.4139 14.7856 16.9286 14.7856C14.4434 14.7856 12.4286 12.7709 12.4286 10.2856C12.4286 9.93053 12.1408 9.64272 11.7858 9.64272C11.4307 9.64272 11.1429 9.93053 11.1429 10.2856C11.1429 13.2637 13.3931 15.7163 16.286 16.036L16.2858 19.2856C16.2858 19.6406 16.5736 19.9284 16.9286 19.9284C17.2837 19.9284 17.5715 19.6406 17.5715 19.2856L17.5721 16.0359C20.4646 15.7159 22.7144 13.2634 22.7144 10.2856ZM16.9286 3.857C15.7452 3.857 14.7858 4.81639 14.7858 5.99986V10.2856C14.7858 11.469 15.7452 12.4284 16.9286 12.4284C18.1121 12.4284 19.0715 11.469 19.0715 10.2856V5.99986C19.0715 4.81639 18.1121 3.857 16.9286 3.857ZM20.9315 16.2856H22.2858V17.1085C22.2858 18.3085 21.3086 19.2856 20.1086 19.2856H18.8572V17.9399H20.1086C20.5629 17.9399 20.9401 17.5628 20.9401 17.1085H20.9315V16.2856ZM12.8572 7.9542V9.30849H12.7801C11.5629 9.30849 10.7315 8.32277 10.6458 8.21134L9.46293 6.59134L9.45961 6.58631C9.40112 6.49734 8.82625 5.62277 8.01436 5.62277H3.8915C3.43721 5.62277 3.06007 5.99992 3.06007 6.4542V17.1085C3.06007 17.5628 3.43721 17.9399 3.8915 17.9399H14.5715V19.2856H3.8915C2.6915 19.2856 1.71436 18.3085 1.71436 17.1085V6.4542C1.71436 5.2542 2.6915 4.27706 3.8915 4.28563H8.00578C8.64007 4.28563 9.16293 4.52563 9.57436 4.81706C9.57436 4.81706 10.1315 5.20277 10.8172 6.16277L11.7172 7.38849C11.9229 7.67992 12.2915 7.9542 12.7801 7.9542H12.8572Z"
				/>
			</Svg>
		);
	}
);
SvgFolderRec24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgFolderRec24;
